import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { StandardDialog } from '@roc/ui';
import { PricingEconomicsStepper } from './pricingEconomicsStepper';
import { CompanyProfileStore } from '../../stores/companyProfileStore';
import TermTierSelection from './termTierSelection';
import { SearchBorrowersForPricingEconomicsTier } from './searchBorrowersForPricingEconomicsTier';
import PricingEconomicsDefaultFees from './pricingEconomicsDefaultFees';

export type AddPricingEconomicsTierDialogProps = {
  open: boolean;
  handleClose: () => void;
  title: string;
  companyProfileStore: CompanyProfileStore
};

export const EditBorrowerTierDialog = observer((props: AddPricingEconomicsTierDialogProps) => {
  const { open, handleClose, title, companyProfileStore } = props;
  const { lenderTermTierEconomicsFormStore } = companyProfileStore;
  const stepsLabels = ['Term Tier Selection']
  const stepsContent = [<TermTierSelection defaultNewEconomicTier={false} showRadioField={false} companyProfileStore={companyProfileStore} />]

  const onSave = () => {
    lenderTermTierEconomicsFormStore.moveBorrowerToNewTermTier()
    if (lenderTermTierEconomicsFormStore.form.fields.existingTermTier.error === false) {
      handleClose()
    }
  }

  return (
    <StandardDialog
      maxWidth={'md'}
      open={open}
      title={title}
      handleClose={handleClose}
      dialogContent={
        <>
          <PricingEconomicsStepper onSave={onSave} stepsLabel={stepsLabels} stepsContent={stepsContent} companyProfileStore={companyProfileStore} />
        </>
      }
    />
  );
});

export default EditBorrowerTierDialog;
